'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$79() {
  this.bmz = null;
  this.bmA = false;
}
export { $c_Lpresto_PrestoRouter$$anon$79 as $c_Lpresto_PrestoRouter$$anon$79 };
$p = $c_Lpresto_PrestoRouter$$anon$79.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$79;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$79() {
}
export { $h_Lpresto_PrestoRouter$$anon$79 as $h_Lpresto_PrestoRouter$$anon$79 };
$h_Lpresto_PrestoRouter$$anon$79.prototype = $p;
$p.bY = (function() {
  if ((!this.bmA)) {
    this.bmz = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_T$package$EmptyTuple$();
    this.bmA = true;
  }
  return this.bmz;
});
$p.P = (function() {
  return this.bY();
});
var $d_Lpresto_PrestoRouter$$anon$79 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$79, "presto.PrestoRouter$$anon$79", ({
  OW: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$79 as $d_Lpresto_PrestoRouter$$anon$79 };
//# sourceMappingURL=presto.-Presto-Router$$anon$79.js.map
